module.exports = __webpack_public_path__ + "img/41.8ac8d089.png";